// extracted by mini-css-extract-plugin
module.exports =  {"tc-action-list":"ActionList-module__tc-action-list___hFkPp","tc-action-list-item":"ActionList-module__tc-action-list-item___UMZKs"};